<template>
  <div class="lm_figuare">
    <section class="img"><img class="is_block" :src="src" /></section>
    <section class="panel">
      <div>{{ description }}</div>
      <div class="item" v-for="(item, i) in list" :key="i">
        <h3 class="tt">{{ item.title }}</h3>
        <p class="intro">{{ item.intro }}</p>
        <p class="is_link" style="text-align: left" v-for="article in item.articles" :key="article.id"
          @click="artilceIdArticle(article.id, article.article_url)">{{ article.article_title }}</p>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';

.lm_figuare {
  display: flex;
  position: relative;

  .img {
    flex: 1;
    display: flex;
    align-items: center;
    position: relative;
    z-index: 1;

    img {
      box-shadow: $shallowShadow;
    }
  }

  .panel {
    flex: 1;
    box-sizing: border-box;
    margin-left: -70px;
    padding: 70px 70px 70px 122.5px;
    background-color: #f4f4f4;

    .intro {
      font-size: 1em;
    }

    .is_link {
      font-size: 1em;
    }
  }
}


.item {
  margin-bottom: 20px;

  .tt {
    text-align: left;
  }

  .intro {
    text-align: left;
    font-size: 14px;
    margin-bottom: 12px;
  }

  .btn {
    font-size: 16px;
    cursor: pointer;
    color: #409eff;
  }
}
</style>

<script>
import ModuleSection from '../../views/column/components/ModuleSection.vue';
import { methodsMixins } from '@/mixins/index';

export default {
  mixins: [methodsMixins],
  components: {
    ModuleSection
  },
  name: 'LmFiguare',
  props: {
    description: {
      type: String
    },
    src: {
      type: String,
      require: true
    },
    list: {
      type: Array,
      require: true
    }
  },
  methods: {
    handleToArticle(menu1Id, menu2Id) {
      const { origin, pathname } = window.location;
      window.open(origin + pathname + `#/article?menu1Id=${menu1Id}&menu2Id=${menu2Id}`)
    }
  }
}
</script>
